import Overview from './overview.view.vue';

export default [
  {
    path: '/',
    component: Overview,
    name: 'Visão Geral',
  },
];
